import { Flex } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { IconButton } from 'src/design-system/IconButton';
import { Button } from 'src/design-system/Button';

type FlowNavigationFooterProps = {
  onBack: () => void;
  onAction: () => void;
  actionLabel?: string;
  actionDisabled?: boolean;
  actionLoading?: boolean;
};

export function FlowNavigationFooter({
  onBack,
  onAction,
  actionLabel = 'Continue',
  actionDisabled,
  actionLoading,
}: FlowNavigationFooterProps) {
  return (
    <Flex gap="sm" align="center">
      <IconButton size={48} bg="gray.1" c="gray.9" onClick={onBack}>
        <IconArrowLeft size={20} />
      </IconButton>
      <Button
        variant="primary"
        px={44}
        disabled={actionDisabled}
        loading={actionLoading}
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    </Flex>
  );
}
